module.exports = __webpack_public_path__ + "static/media/ios-help-buoy.07ac0589.svg";